export const messages = {
  postRecoveryTitle: {
    id: 'LOGIN_RECOVERY_SUCESSFUL_RESET_TITLE',
    defaultMessage: 'Prima, Sie haben ein neues Passwort',
  },
};
